module.exports = __webpack_public_path__ + "static/media/Recipe_selected.d2a59a94.svg";